import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=336a091f&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=ts&"
export * from "./Research.vue?vue&type=script&lang=ts&"
import style0 from "./Research.vue?vue&type=style&index=0&id=336a091f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a091f",
  null
  
)

export default component.exports